<template>
<header id="header">
    <nav class="navbar container">
        <div class="navbar-brand">
            <h1 :class="['navbar-item', {'is-paddingless-horizontal': true }]" v-if="site_data.pagetype == 'HomePage'">
                <router-link id="logo" rel="start" to="/"><img class="is-block" v-if="site_data.siteconfig.logo" :src="site_data.siteconfig.logo.url" :alt="site_data.siteconfig.title" /><template v-else>{{site_data.siteconfig.title}}</template></router-link>
            </h1>
            <router-link :class="['navbar-item', {'is-paddingless-horizontal': true }]" id="logo" rel="start" v-else to="/"><img class="is-block" v-if="site_data.siteconfig.logo" :src="site_data.siteconfig.logo.url" :alt="site_data.siteconfig.title" /><template v-else>{{site_data.siteconfig.title}}</template></router-link>
            <div class="navbar-search" v-if="$route.path.rtrim('/') != site_data.siteconfig.search_page.rtrim('/')">
                <button class="button neat" @click.prevent="show_search = !show_search;"><span class="icon"><i class="fas fa-search"></i></span></button>
            </div>
            <div v-on:click="show_mobile_menu" :class="{'navbar-burger': true, 'burger': true, 'is-active': mobile_menu_is_active}" data-target="mobile-menu">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div v-if="is_mobile" id="mobile-menu" :class="{'navbar-menu': true, 'is-active': mobile_menu_is_active}">
            <div class="navbar-end">
                <template v-for="item in site_data.navigation">
                    <router-link :class="['navbar-item', {'is-active': item.active}]" :to="item.url">{{item.label}}</router-link>
                </template>
            </div>
        </div>
        <div :class="['navbar-end is-aligned-centred search-form-holder', {'is-active': show_search}]">
            <SearchForm v-if="$route.path.rtrim('/') != site_data.siteconfig.search_page.rtrim('/')" :action="site_data.siteconfig.search_page" />
        </div>
    </nav>
    <div v-if="!is_mobile" class="navbar__desktop section">
        <div class="container">
            <nav class="columns is-variable is-1">
                <div class="column" v-for="item in site_data.navigation">
                    <router-link :class="[{'is-active': item.active}]" :to="item.url">{{item.label}}</router-link>
                </div>
            </nav>
        </div>
    </div>
</header>
</template>
<script>
import SearchForm from './forms/SearchForm';
export default {
    name        :   'Header',
    props       :   ['site_data'],
    components  :   { SearchForm },
    data()
    {
        return {
            is_mobile               :   false,
            show_search             :   false,
            mobile_menu_is_active   :   false
        }
    },
    created()
    {
        this.$bus.$on('onWindowSize', this.resize_handler);
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowSize', this.resize_handler);
    },
    methods: {
        resize_handler(width)
        {
            this.is_mobile  =   width <= 768;
        },
        click_to_close: function(e) {
            let target = $(e.target);
            if (!target.is('.burger') &&
                target.parents('.burger').length == 0 &&
                !target.is('.navbar-item') &&
                target.parents('.navbar-item').length == 0) {

                this.mobile_menu_is_active = false;
                $(window).unbind('mousedown', this.click_to_close);
            }
        },
        show_mobile_menu: function(e) {
            e.preventDefault();
            this.show_search    =   false;
            $(window).unbind('mousedown', this.click_to_close).on('mousedown', this.click_to_close);
            this.mobile_menu_is_active = !this.mobile_menu_is_active;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Header.vue